import axios, { AxiosResponse } from 'axios';
import { UserCartAddItemsRequest, UserCartItemValue, UserCartValue } from '@/venit/services/model/techpubs-cms';

export default class UserCartService {
  public addItemsToCart(items: UserCartItemValue[]): Promise<AxiosResponse<UserCartValue>> {
    const request: UserCartAddItemsRequest = {
      itemsToAdd: items,
    };
    return axios.post<UserCartValue>(`/api/user/cart/items`, request);
  }
}
